import { getTokenFromLocal, handleResponse } from "../../_helpers/handleResponseMiddleware";

let apiUrl = process.env.REACT_APP_CENTRAL_BASE_URL;
let commonApiUrl = process.env.REACT_APP_BASE_URL_COMMON;

export const centralCommonDataService = {
    fetchCentralCancelAppointmentData
};

export function fetchCentralCancelAppointmentData() {
  let user = getTokenFromLocal();
  let token = user ? user.access_token : null;

  const config = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      // mobileplatform: "web",
      "Content-Type": "application/json",
    },
  };

  return fetch(`${commonApiUrl}/api/getcommondata?Name=appointmentCancellationReasonfilters`, config)
    .then(handleResponse)
    .then(res => res)
    .catch((error) => {
      console.error(error);
    })
    .then(response =>response);
}

export const updateCentralAppointmentStatus = async (payload) => {
  let user = getTokenFromLocal();
  let token = user ? user.access_token : null;

  const requestOptions = {
      method: 'POST',
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json' 
      },
      body: JSON.stringify(payload)
  };

  return fetch(`${apiUrl}/updateCentralDashRepoting`, requestOptions)
      .then(handleResponse)
      .catch(error => {
          console.error('Error updating appointment status:', error);
          throw error;
      });
};

export function fetchCentralMedicalManagementData() {
  let user = getTokenFromLocal();
  let token = user ? user.access_token : null;

  const config = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      // mobileplatform: "web",
      "Content-Type": "application/json",
    },
  };

  return fetch(`${commonApiUrl}/api/getcommondata?Name=medicalManagementFilters`, config)
    .then(handleResponse)
    .then(res => res)
    .catch((error) => {
      console.error(error);
    })
    .then(response =>response);
}
export function fetchCentralIpdTypeData (payload) {
  let user = getTokenFromLocal();
  let token = user ? user.access_token : null;

  const requestOptions = {
      method: 'POST',
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json' 
      },
      body: JSON.stringify(payload)
  };

  return fetch(`${apiUrl}/getCommonDataValues`, requestOptions)
      .then(handleResponse)
      .catch(error => {
          console.error('Error updating appointment status:', error);
          throw error;
      });
}